import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-download-materials-section',
  templateUrl: './download-materials-section.component.html',
  styleUrls: ['./download-materials-section.component.scss']
})
export class DownloadMaterialsSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
